module.exports = __webpack_public_path__ + "static/media/2014_aug_mort.688975f8.jpg";